var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAngleDown = function SvgAngleDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "Angle-Down_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 5,
    width: 12,
    height: 7
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3 6.002 4.622 5.021a.516.516 0 0 0 .754 0L13 6.002",
    stroke: "#14161A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Angle-Down_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#14161A",
    d: "M0 0h16v16H0z"
  }))));
};
export { SvgAngleDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swXzIxODdfMjY3MyIgc3R5bGU9Im1hc2stdHlwZTphbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMiIgeT0iNSIgd2lkdGg9IjEyIiBoZWlnaHQ9IjciPgo8cGF0aCBkPSJNMi45OTkyNyA2LjAwMTU5TDcuNjIyMzQgMTEuMDIzMUM3LjY3MDY5IDExLjA3NDYgNy43MjkwOCAxMS4xMTU3IDcuNzkzOSAxMS4xNDM3QzcuODU4NzMgMTEuMTcxOCA3LjkyODYzIDExLjE4NjMgNy45OTkyNyAxMS4xODYzQzguMDY5OTEgMTEuMTg2MyA4LjEzOTggMTEuMTcxOCA4LjIwNDYzIDExLjE0MzdDOC4yNjk0NiAxMS4xMTU3IDguMzI3ODUgMTEuMDc0NiA4LjM3NjE5IDExLjAyMzFMMTIuOTk5MyA2LjAwMTU5IiBzdHJva2U9IiMxNDE2MUEiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9tYXNrPgo8ZyBtYXNrPSJ1cmwoI21hc2swXzIxODdfMjY3MykiPgo8cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IiMxNDE2MUEiLz4KPC9nPgo8L3N2Zz4K";